<template>
  <div class="container p-5">
      <TagsInput :placeHolder="'Input categories'"  @change="(v) => (categories = v)" />

      {{categories}}

      <!-- <TagsInput :placeHolder="'asdasd'" :delimiter="','" :data="categories"/> -->

  </div>
</template>

<script>
import TagsInput from "@/components/TagsInput";

export default {
  name: "test",
  components: { TagsInput },
  data() {
    return {
      categories: null,
    };
  },

  created() {},

  mounted() {},

  methods: {},
};
</script>


<style lang="scss">
</style>